{
    "Budō Lineage Tree": "Kampfkünste-Stammbaum",
    "Teachers": "Lehrer",
    "Students": "Studenten",
    "Rank": "Grad",
    "Sources": "Quellen",
    "Tree": "Baum",
    "Persons": "Personen",
    "Styles": "Stile",
    "All Styles": "Alle Stile",
    "Timeline": "Zeitleiste"
}
